// components/NotificationSystem.js
import React, { useState, useEffect } from 'react';
import { useWebSocket } from '../hooks/useWebSocket';
import { toast } from 'react-toastify';

const NotificationBadge = ({ count }) => (
  <span className="inline-flex items-center justify-center px-2 py-1 text-xs font-bold leading-none text-white bg-red-600 rounded-full">
    {count > 99 ? '99+' : count}
  </span>
);

const NotificationItem = ({ notification, onRemove, onDownload }) => {
  const getIcon = () => {
    switch (notification.type) {
      case 'success': return '✅';
      case 'error': return '❌';
      case 'info': return 'ℹ️';
      default: return '📄';
    }
  };

  const getBorderColor = () => {
    switch (notification.type) {
      case 'success': return 'border-green-500';
      case 'error': return 'border-red-500';
      case 'info': return 'border-blue-500';
      default: return 'border-gray-300';
    }
  };

  return (
    <div className={`border-l-4 ${getBorderColor()} bg-white p-4 shadow-md mb-2 rounded-r-lg`}>
      <div className="flex items-start justify-between">
        <div className="flex items-start space-x-3">
          <span className="text-lg">{getIcon()}</span>
          <div className="flex-1">
            <h4 className="font-medium text-gray-900">
              {notification.title}
              {notification.personal && <span className="ml-2 text-xs bg-blue-100 text-blue-800 px-2 py-1 rounded">Personale</span>}
            </h4>
            <p className="text-sm text-gray-600 mt-1">{notification.message}</p>
            <p className="text-xs text-gray-400 mt-1">
              {new Date(notification.timestamp).toLocaleString('it-IT')}
            </p>
          </div>
        </div>
        <div className="flex items-center space-x-2">
          {notification.downloadUrl && (
            <button
              onClick={() => onDownload(notification.downloadUrl)}
              className="text-blue-600 hover:text-blue-800 text-sm font-medium"
            >
              Scarica
            </button>
          )}
          <button
            onClick={() => onRemove(notification.id)}
            className="text-gray-400 hover:text-gray-600"
          >
            ×
          </button>
        </div>
      </div>
    </div>
  );
};

const SystemStatsBar = ({ stats }) => (
  <div className="bg-gradient-to-r from-blue-500 to-purple-600 text-white p-3 rounded-lg mb-4">
    <div className="flex justify-between items-center text-sm">
      <span>PDF Generati: <strong>{stats.totalPdfsGenerated || 0}</strong></span>
      <span>Generazioni Attive: <strong>{stats.activeGenerations || 0}</strong></span>
      <span className="text-xs opacity-75">
        {stats.lastUpdate && `Aggiornato: ${new Date(stats.lastUpdate).toLocaleTimeString('it-IT')}`}
      </span>
    </div>
  </div>
);

export const NotificationSystem = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [unreadCount, setUnreadCount] = useState(0);
  const { isConnected, notifications, systemStats, clearNotifications, removeNotification } = useWebSocket(
    process.env.NODE_ENV === 'production' 
      ? `wss://${process.env.REACT_APP_API_BASE_URL.replace("https://", "").replace("/api/v1/", "")}/ws/pdf-notifications/`
      : 'ws://localhost:8000/ws/pdf-notifications/'
  );

  useEffect(() => {
    // Richiedi permessi notifiche
    if ('Notification' in window && Notification.permission === 'default') {
      Notification.requestPermission();
    }
  }, []);

  useEffect(() => {
    // Aggiorna contatore notifiche non lette
    if(notifications.length > 0) {
      console.log(notifications)
      toast.success(notifications[0].message);
      setUnreadCount(0);
      clearNotifications();
    }
  }, [notifications.length, isOpen]);

  const handleDownload = (url) => {
    window.open(url, '_blank');
  };

  const handleToggle = () => {
    setIsOpen(!isOpen);
    if (!isOpen) {
      setUnreadCount(0);
    }
  };

  return (
    <React.Fragment />
  );
};